var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { ExternalRouteLink, InternalRouteLink } from './subcomponents';
const isInternalLink = (props) => !!props.to;
const Link = forwardRef((props, ref) => {
    const { className, isDisabled, alt, children, isInline = false, to } = props, rest = __rest(props, ["className", "isDisabled", "alt", "children", "isInline", "to"]);
    if (isInternalLink(props)) {
        return (React.createElement(InternalRouteLink, Object.assign({}, rest, { className: className, isDisabled: isDisabled, alt: alt, isInline: isInline, to: !isDisabled && to, ref: ref }), children));
    }
    const { href } = props;
    return (React.createElement(ExternalRouteLink, Object.assign({}, rest, { className: className, isDisabled: isDisabled, alt: alt, href: isDisabled ? null : href, isInline: isInline }), children));
});
export default Link;
